import { ManagerShortType } from '~/types';

export interface ModalData {
  invitationId: string;
  isOpen: boolean;
  manager?: ManagerShortType;
  invitationAgencyName?: string;
}

export const createEmptyModalData = (): ModalData => ({
  invitationId: '',
  isOpen: false,
});
